<template>
  <router-view v-wechat-title="$route.meta.title + ' - ' + organizationName" />
</template>

<script>
import Opinionaire from '@/views/common/Opinionaire'
export default {
  data () {
    return {
      organizationName: null,
    }
  },
  mounted () {
    window.addEventListener('keydown', this.disablePrint);
    this.init()
  },
  beforeDestroy () {
    // Clean up the event listener when the component is destroyed
    window.removeEventListener('keydown', this.disablePrint);
  },
  methods: {
    init () {
      if (window.localStorage.getItem('organizationName') == null ||
        window.localStorage.getItem('organizationName') == 'null' ||
        window.localStorage.getItem('organizationName') == 'undefined') {
        this.organizationName = this.GLOBAL.organizationName
      } else {
        this.organizationName = window.localStorage.getItem('organizationName')
      }
      this.timer()
    },
    timer () {
      setTimeout(() => { this.init(false) }, 1000)
    },
    disablePrint (event) {
      console.log("*****")
      if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
        event.preventDefault();
        console.log('Printing is disabled');
        // You can also show a message to the user that printing is disabled
      }
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
</style>
